import * as discountCodeHelper from '../../helpers/discount_codes';

export function calculateTotalPrice (lineItem) {
    const { price } = lineItem;
    let basePrice = (price.manual === null)
        ? price.discounted
        : (price.manual || 0); // the manual price might be an empty string

    let total = (lineItem.quantity * basePrice);

    if (lineItem.price.discount && lineItem.price.discount.quantity > 0) {
        total -= lineItem.price.discount.total;
    }

    return total;
}

export function formatLocationAddress (locationAddress, customer, phone, assignedBillingAddress) {
    if (assignedBillingAddress) {
        return {
            company: assignedBillingAddress.business_name,
            address1: assignedBillingAddress.address_line_1,
            address2: assignedBillingAddress.address_line_2,
            city: assignedBillingAddress.city,
            province: assignedBillingAddress.state,
            zip: assignedBillingAddress.zip_code,
            phone: assignedBillingAddress.phone,
        }
    }
    return locationAddress
        ? {
            firstName: locationAddress.first_name ?? customer.additional_data.first_name,
            lastName: locationAddress.last_name ?? customer.additional_data.last_name,
            company: locationAddress.address1,
            address1: locationAddress.address2,
            address2: locationAddress.address3,
            city: locationAddress.city,
            province: locationAddress.state,
            country: locationAddress.country,
            zip: locationAddress.zip_code,
            phone: phone
        }
        : null;
}

export function getPriceBreak(priceBreaks = {}, quantity = 0) {
    if (!priceBreaks || typeof priceBreaks !== 'object' || quantity <= 0) return null;

    for (const [key, price] of Object.entries(priceBreaks)) {
        const rangeMatch = key.match(/^(\d+)-(\d+)$/);
        if (rangeMatch) {
            const start = parseInt(rangeMatch[1], 10);
            const end = parseInt(rangeMatch[2], 10);
            if (quantity >= start && quantity <= end) {
                return price;
            }
        }

        const openEndMatch = key.match(/^(\d+)\+$/);
        if (openEndMatch) {
            const start = parseInt(openEndMatch[1], 10);
            if (quantity >= start) {
                return price;
            }
        }

        const exactMatch = key.match(/^(\d+)$/);
        if (exactMatch) {
            const exact = parseInt(exactMatch[1], 10);
            if (quantity >= exact) {
                return price;
            }
        }
    }

    return null;
}

export function getDiscountDetails(lineItem) {
    const { price } = lineItem;

    // we have to round it, otherwise JS will do some weird stuff with it
    const totalDiscount = parseFloat(parseFloat(price.discount?.total ?? 0).toFixed(2));

    if (totalDiscount === 0) {
        const manual = parseFloat(price.manual);
        const original = parseFloat(price.original);

        if (price.manual !== null && price.manual !== '' && !isNaN(manual) && manual > 0) {
            return {
                valueType: 'FIXED_AMOUNT',
                value: Number((original - manual).toFixed(2)),
            }
        }

        return null;
    }

    return {
        valueType: 'FIXED_AMOUNT',
        value: Number((totalDiscount / lineItem.quantity).toFixed(2)),
    };
}

export function applyDiscountCode (lineItems, buckets) {
    const originalSortOrder = lineItems.map(item => item.id);
    let updatedLineItems = [...lineItems]
        .sort(
            (left, right) => parseFloat(left.price.discounted) - parseFloat(right.price.discounted)
        )
        .map(item => {
            item.price.discount = null;

            return item;
        });

    buckets.forEach((productBucket) => {
        updatedLineItems = updatedLineItems.map(item => {
            const quantity = parseInt(item.quantity, 10);
            let totalPrice = parseFloat(item.quantity * item.price.original);
            let itemDiscount = item.price.discount ?? {
                quantity: 0,
                total: 0,
                discountCodes: [],
            };
            let unitPrice = (totalPrice - itemDiscount.total) / quantity;
            console.log(item);

            let ids = productBucket.origin_products ?? [productBucket.id];

            if (
                item.price.manual
                || !productBucket.eligible
                || ! quantity
                || !ids.includes(item.shopify_product_id)
            ) {
                return item;
            }

            if (productBucket.eligible_amount === -1) {
                let newTotalPrice = parseFloat(discountCodeHelper.calculateTotalPrice(productBucket.discountCode, unitPrice, quantity)
                    .toFixed(2));

                itemDiscount.quantity = quantity;
                itemDiscount.total += newTotalPrice;
                itemDiscount.discountCodes.push(productBucket.discountCode.code);

                item.price.discount = itemDiscount;


                return item;
            }

            const eligibleAmount = Math.min(productBucket.eligible_amount, quantity);

            if (eligibleAmount > itemDiscount.quantity)
                itemDiscount.quantity = eligibleAmount;

            let newTotalPrice = parseFloat(discountCodeHelper.calculateTotalPrice(productBucket.discountCode, unitPrice, eligibleAmount)
                .toFixed(2));
            itemDiscount.total += newTotalPrice;
            itemDiscount.discountCodes.push(productBucket.discountCode.code);
            item.price.discount = itemDiscount;

            productBucket.eligible_amount -= eligibleAmount;

            return item;
        });
    });

    return {
        lineItems: updatedLineItems
            .map(item => {
                //We do that to ensure that we will not have rounding issues.
                if (item.price.discount && item.price.discount.quantity > 0) {
                    let unitDiscount = parseFloat((item.price.discount.total / item.quantity).toFixed(2));

                    item.price.discount.total = unitDiscount * item.quantity;

                    if (item.price.discount.total > item.price.total) {
                        item.price.discount.total = item.price.total;
                    }
                } else {
                    item.price.discount = null;
                }
                return item;
            })
            .sort(
                (left, right) => originalSortOrder.indexOf(left.id) - originalSortOrder.indexOf(right.id)
            ),
    }
}
